import {useNavigate, useParams} from 'react-router-dom';

import {useGetBanner} from '@entities/banner';
import {BaseWidgetLayout, Header} from '@widgets/common';
import {EditBannerForm} from './EditBannerForm';

export const EditBannerPage = () => {
  const {id} = useParams<{id: string}>();
  const navigate = useNavigate();

  const {data, isPending, error} = useGetBanner(id ?? '', {
    enabled: !!id,
  });

  return (
    <>
      <Header title="Edit banner" mb={1} />

      <BaseWidgetLayout isPending={isPending} error={error}>
        {data && <EditBannerForm banner={data} onClose={() => navigate(-1)} />}
      </BaseWidgetLayout>
    </>
  );
};
